import React from "react";
import { useGwsSettings } from "./gws/useGwsSettings";
import { GwsSettingsHeader, GwsSettingsSummary } from "./gws/GwsSettingsBits";
import { GwsSettingsForm } from "./gws/GwsSettingsForm";

/** Network-wide Google Workspace credentials (one service account for all sites). */
export default function GoogleWorkspaceSettings() {
  const s = useGwsSettings();
  const { cfg, probe, editing, msg, err } = s;
  return (
    <div className="border border-zinc-800 rounded-sm" data-testid="gws-settings">
      <GwsSettingsHeader s={s} />
      <div className="px-5 py-4 space-y-4">
        {cfg?.configured && !editing && <GwsSettingsSummary cfg={cfg} probe={probe} />}
        {(!cfg?.configured || editing) && cfg && <GwsSettingsForm s={s} />}
        {msg && <div className="text-xs text-emerald-400 mono" data-testid="gws-settings-msg">{msg}</div>}
        {err && <div className="text-xs text-red-400 mono" data-testid="gws-settings-err">{err}</div>}
      </div>
    </div>
  );
}
